import React, { useLayoutEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import { Switch } from "components"
import { isDeviceCloudPrinter, toggleDeviceAsCloudPrinter } from "utils"
import classes from "./SSPrinterCloud.module.scss"

const SSPrinterCloud = () => {
  const [t] = useTranslation()

  const [checked, setChecked] = useState(false)

  const handleClick = () => {
    toggleDeviceAsCloudPrinter()

    setChecked(prev => !prev)
  }

  useLayoutEffect(() => {
    setChecked(
      isDeviceCloudPrinter()
    )
  }, [])

  return (
    <div className={classes["row"]}>
      <div>{t("پرینت_ابری_آنلاین")}</div>
      <Switch
        onClick={handleClick}
        checked={checked}
      />
    </div>
  )
}

export default SSPrinterCloud